import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { ADMIN_API } from "../../../common/common";
import { Logout } from "../../../common/Funcation";
import {
  styleObjectBlackButton,
  getTheme,
  hexToYIQTextColor,
} from "../../../common/StyleSeter";
import ImageUpload from "../../../components/ImageUpload";
import { postApi, notifyMessage, notifyError, getApi } from "../../../service";
import { AddDashBoardImage } from "../interface";
import { DASHBOARD_WEBSITE_STORAGE_KEY } from "../ManageDashboard";
import GameCatalogPicker, {
  CatalogGame,
} from "../components/GameCatalogPicker";
import {
  VELKI_GAME_GROUPS,
  canonicalVelkiGameType,
  velkiGroupFromGameType,
} from "../velkiDashboard";

function EditDashBoard() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const MODE =
    window.location.pathname.includes("edit-dashboard") && id ? "EDIT" : "ADD";
  const locationState = (location.state || {}) as {
    websiteId?: string;
    websiteTitle?: string;
    websiteDomain?: string;
    websiteTheme?: string;
    gameGroup?: string;
    catalog?: string;
  };
  const presetGroup =
    locationState.websiteTheme === "velki" ? locationState.gameGroup || "" : "";
  const presetType = canonicalVelkiGameType(presetGroup);
  const presetCatalog =
    presetGroup === "Live" &&
    locationState.catalog &&
    locationState.catalog !== "__none"
      ? locationState.catalog
      : "";

  const emptyFormData: AddDashBoardImage = {
    title: "",
    image: "",
    link: "#",
    Width: "squareSize",
    gameCode: "",
    gameTableId: "",
    gameName: "",
    gameType: "",
    platform: "",
    gameLimit: "",
    catalog: "",
    isLatest: false,
    isHot: false,
    isLaunchGameTable: false,
    position: "bottom",
    insertAfter: "",
  };

  const [formData, setFormData] = useState<AddDashBoardImage>({
    ...emptyFormData,
    ...(MODE === "ADD" && presetType ? { gameType: presetType } : {}),
    ...(MODE === "ADD" && presetGroup === "Live" ? { catalog: presetCatalog } : {}),
  });
  const [imageUploadKey, setImageUploadKey] = useState(0);
  const [existingTiles, setExistingTiles] = useState<any[]>([]);

  const [websiteId, setWebsiteId] = useState(
    () => (MODE === "ADD" ? id : locationState.websiteId) || "",
  );
  const [websiteTitle, setWebsiteTitle] = useState(
    locationState.websiteTitle || "",
  );
  const [websiteDomain, setWebsiteDomain] = useState("");
  const [websiteTheme, setWebsiteTheme] = useState(
    locationState.websiteTheme === "velki"
      ? "velki"
      : locationState.websiteTheme === "sky-sky"
        ? "sky-sky"
        : "",
  );

  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const [, updateState] = useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const Validator = useRef(new SimpleReactValidator());

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const rememberWebsiteAndGoBack = (domainId?: string) => {
    const selectedId = domainId || websiteId || (MODE === "ADD" ? id : "");
    if (selectedId) {
      try {
        sessionStorage.setItem(DASHBOARD_WEBSITE_STORAGE_KEY, selectedId);
      } catch {}
      const params = new URLSearchParams();
      params.set("website", selectedId);
      if (websiteTheme === "velki") {
        const group =
          velkiGroupFromGameType(formData.gameType) ||
          locationState.gameGroup ||
          "all";
        params.set("group", group);
        if (group === "Live") {
          const nextCatalog = formData.catalog
            ? formData.catalog
            : locationState.catalog || "";
          if (nextCatalog) params.set("catalog", nextCatalog);
        }
      }
      navigate(`/dashboard-images?${params.toString()}`);
      return;
    }
    navigate("/dashboard-images");
  };
  useEffect(() => {
    if (id && MODE === "EDIT") {
      getEditData();
    } else if (MODE === "EDIT" && !id) {
      rememberWebsiteAndGoBack();
    }
  }, [id]);

  useEffect(() => {
    const domainId = MODE === "ADD" ? id : websiteId;
    setWebsiteDomain("");
    if (!domainId) return;
    let cancelled = false;
    getApi({ api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN })
      .then((response: any) => {
        if (cancelled) return;

        const match = (response.data.data || []).find(
          (item: any) => item?._id === domainId,
        );
        setWebsiteDomain(match?.domain || "");
        if (match?.theme) {
          setWebsiteTheme(match.theme === "velki" ? "velki" : "sky-sky");
        }
      })
      .catch(console.error);

    return () => {
      cancelled = true;
    };
  }, [id, websiteId, MODE]);

  useEffect(() => {
    const domainId = MODE === "ADD" ? id : websiteId;
    // setWebsiteDomain("");
    if (!domainId || websiteTitle) return;
    getApi({ api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN })
      .then((response: any) => {
        const match = (response.data.data || []).find(
          (item: any) => item?._id === domainId,
        );
        // setWebsiteDomain(match?.domain || "");
        if (match) setWebsiteTitle(match.title || match.domain || "");
      })
      .catch(() => {});
  }, [id, websiteId, websiteTitle, MODE]);

  const getEditData = async () => {
    let data: any = {
      api: ADMIN_API.SETTING.DASHBOARD.GET_ONE,
      value: {
        id: id,
      },
    };
    await postApi(data)
      .then(function (response) {
        const item = response.data.data;
        const domainValue =
          typeof item?.domain === "object" ? item?.domain?._id : item?.domain;
        if (domainValue) setWebsiteId(String(domainValue));
        setFormData({
          title: item.title,
          link: item.link,
          image: item.image,
          Width: item.Width || "squareSize",
          gameCode: item.gameCode,
          gameTableId: item.gameTableId || "",
          gameName: item.gameName,
          gameType: item.gameType,
          platform: item.platform,
          gameLimit: item.gameLimit,
          catalog: item?.catalog,
          isLatest:
            item?.isLatest === true ||
            item?.isLatest === "true" ||
            item?.isLatest === 1,
          isHot:
            item?.isHot === true || item?.isHot === "true" || item?.isHot === 1,
          isLaunchGameTable:
            item?.isLaunchGameTable === true ||
            item?.isLaunchGameTable === "true" ||
            item?.isLaunchGameTable === 1,
        });
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (
      name === "isLatest" ||
      name === "isHot" ||
      name === "isLaunchGameTable"
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: !prev[name as keyof AddDashBoardImage],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(name === "catalog" || name === "gameType" ? { insertAfter: "" } : {}),
      }));
    }
  };

  const handleImageUpload = (value: string, name: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const loadExistingTiles = async () => {
    const domainId = MODE === "ADD" ? id : websiteId;
    if (!domainId || MODE !== "ADD") {
      setExistingTiles([]);
      return;
    }
    try {
      const response = await postApi({
        api: ADMIN_API.SETTING.DASHBOARD.GET_LIST,
        value: (() => {
          const group =
            websiteTheme === "velki"
              ? velkiGroupFromGameType(formData.gameType)
              : "";
          const value: any = {
            domain: domainId,
            page: 1,
            limit: 1000,
          };
          if (group) {
            value.gameGroup = group;
            if (group === "Live") {
              value.catalog = formData.catalog ? formData.catalog : "__none";
            }
          }
          return value;
        })(),
      });
      setExistingTiles(response?.data?.data?.results || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (MODE === "ADD") {
      loadExistingTiles();
    }
  }, [id, websiteId, MODE, websiteTheme, formData.gameType, formData.catalog]);

  const getPageData = async () => {
    const payload: any = {
      ...formData,
      Width: formData.Width || "squareSize",
    };
    if (id && MODE === "EDIT") {
      payload.id = id;
      delete payload.position;
      delete payload.insertAfter;
    } else {
      payload.domain = id;
      payload.position = formData.position || "bottom";
      if (payload.position === "after" && formData.insertAfter) {
        payload.insertAfter = formData.insertAfter;
      } else {
        delete payload.insertAfter;
      }
    }
    let data: any = {
      api:
        id && MODE === "EDIT"
          ? ADMIN_API.SETTING.DASHBOARD.UPDATE
          : ADMIN_API.SETTING.DASHBOARD.CREATE,
      value: payload,
    };

    await postApi(data)
      .then(function (response) {
        notifyMessage(
          response.data.message ||
            (MODE === "ADD"
              ? "Dashboard image saved successfully."
              : "Dashboard image updated successfully."),
        );
        if (MODE === "EDIT") {
          rememberWebsiteAndGoBack();
          return;
        }
        setFormData({ ...emptyFormData });
        setImageUploadKey((k) => k + 1);
        Validator.current.hideMessages();
        forceUpdate();
        loadExistingTiles();
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch((err) => {
        notifyError(
          err.response?.data?.message || "Failed to save dashboard image",
        );
        if (err.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleSubmitClick = (e: any) => {
    e.preventDefault();
    if (
      websiteTheme === "velki" &&
      !velkiGroupFromGameType(formData.gameType)
    ) {
      notifyError("Select a game type: Live, Table, Slot, Fishing, or Egame.");
      return;
    }
    if (Validator.current.allValid()) {
      getPageData();
    } else {
      Validator.current.showMessages();
      forceUpdate();
      notifyError("Please fill in all the required fields correctly");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCancelClick = (e: any) => {
    e.preventDefault();
    rememberWebsiteAndGoBack();
  };

  const catalogWebsiteId =
    (MODE === "ADD" ? id : websiteId) || websiteId || "";

  const applyCatalogGame = (game: CatalogGame, copiedImage?: string) => {
    setFormData((prev) => ({
      ...prev,
      title: game.gameName || prev.title,
      gameName: game.gameName || "",
      gameCode: game.gameCode || "",
      gameTableId: "",
      gameType: game.gameType || "",
      platform: game.platform || "",
      link: prev.link || "#",
      image: copiedImage || prev.image || "",
    }));
  };

  const handleCatalogDrop = async (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const raw = e.dataTransfer.getData("application/x-catalog-game");
    if (!raw) return;
    try {
      const game = JSON.parse(raw) as CatalogGame;
      let copiedImage = "";
      if (game.hasSpacesImage && game.spacesImage && catalogWebsiteId) {
        try {
          const response = await postApi({
            api: ADMIN_API.SETTING.DASHBOARD.CATALOG_COPY_IMAGE,
            value: {
              gameCode: game.gameCode,
              websiteId: catalogWebsiteId,
              sourceImage: game.spacesImage,
            },
          });
          copiedImage = response?.data?.data?.image || "";
        } catch (err: any) {
          notifyError(
            err?.response?.data?.message ||
              "Could not copy Spaces image. Upload manually.",
          );
        }
      }
      applyCatalogGame(game, copiedImage || undefined);
    } catch {
      notifyError("Invalid catalog game drop.");
    }
  };

  return (
    <div
      className="container banking website edit main_wrap"
      style={{ paddingTop: "18px", paddingBottom: "30px" }}
    >
      <div
        className="top_header"
        style={{
          marginBottom: "15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div className="top_header_title align-items-center">
          <h5
            className="font-weight-bold mb-1"
            style={{ fontSize: "18px", color: "#212529" }}
          >
            {MODE === "EDIT" ? "Update Dashboard Image" : "Add Dashboard Image"}
          </h5>
          {websiteTitle && (
            <p
              className="mb-0"
              style={{ fontSize: "14px", marginTop: "6px", color: "#6c757d" }}
            >
              Website:{" "}
              <strong style={{ color: "#212529" }}>{websiteTitle}</strong>
              <span style={{ marginLeft: 8, color: "#868e96" }}>
                {websiteTheme === "velki"
                  ? "· Velki order stays inside the selected game type"
                  : "· Click or drag a game from the left to fill fields"}
              </span>
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={() => rememberWebsiteAndGoBack()}
          style={{
            height: 34,
            padding: "0 14px",
            borderRadius: 6,
            border: "1px solid #d0d5dd",
            background: "#fff",
            color: "#344054",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          ← Back
        </button>
      </div>

      <div
        className="edit_body"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: 16,
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "0 0 40%",
            maxWidth: 560,
            minWidth: 340,
            alignSelf: "stretch",
          }}
        >
          <GameCatalogPicker
            websiteId={catalogWebsiteId}
            onPick={applyCatalogGame}
          />
        </div>

        <div
          style={{ flex: "1 1 60%", minWidth: 0 }}
          onDragOver={(e) => {
            e.preventDefault();
            e.dataTransfer.dropEffect = "copy";
          }}
          onDrop={handleCatalogDrop}
        >
          <div
            className="card"
            style={{
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              width: "100%",
              maxWidth: "100%",
            }}
          >
            <div className="row" style={{ margin: 0, display: "flex", flexWrap: "wrap" }}>
              <div className="col-6 p_15">
              <div className="mb-3 p_0 col-12">
                <label htmlFor="title" className="mb_5 d_block">
                  Title:{" "}
                  <span
                    style={{
                      color: "#dc3545",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="title"
                  type="text"
                  value={formData.title}
                  id="title"
                />
                <span className="text-danger">
                  {Validator.current.message(
                    "title",
                    formData.title,
                    "required",
                  )}
                </span>
              </div>

              <div className="mb-3 p_0 col-12">
                <label htmlFor="link" className="mb_5 d_block">
                  Link:{" "}
                  <span
                    style={{
                      color: "#dc3545",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="link"
                  type="text"
                  value={formData.link}
                  id="link"
                />
                <span className="text-danger">
                  {Validator.current.message("link", formData.link, "required")}
                </span>
              </div>

              <div className="mb-3 p_0 col-12">
                <label htmlFor="theme" className="mb_5 d_block">
                  Size:
                </label>
                <select
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  id="Width"
                  name="Width"
                  value={formData.Width || "squareSize"}
                >
                  <option value="fullSize">Full Size</option>
                  <option value="halfWidth">Half Width</option>
                  <option value="squareSize">Square Size</option>
                </select>
              </div>

              {MODE === "ADD" && (
                <>
                  <div className="mb-3 p_0 col-12">
                    <label htmlFor="position" className="mb_5 d_block">
                      Position:
                    </label>
                    <select
                      className="form-control"
                      onChange={(e) => handleInputChange(e)}
                      id="position"
                      name="position"
                      value={formData.position || "bottom"}
                    >
                      <option value="bottom">
                        {websiteTheme === "velki"
                          ? "Bottom of this section"
                          : "Bottom (end of list)"}
                      </option>
                      <option value="top">
                        {websiteTheme === "velki"
                          ? "Top of this section"
                          : "Top (start of list)"}
                      </option>
                      <option value="after">
                        {websiteTheme === "velki"
                          ? "After an image in this section"
                          : "After an existing image"}
                      </option>
                    </select>
                  </div>
                  {formData.position === "after" && (
                    <div className="mb-3 p_0 col-12">
                      <label htmlFor="insertAfter" className="mb_5 d_block">
                        Insert after:
                      </label>
                      <select
                        className="form-control"
                        onChange={(e) => handleInputChange(e)}
                        id="insertAfter"
                        name="insertAfter"
                        value={formData.insertAfter || ""}
                      >
                        <option value="">Select image…</option>
                        {existingTiles.map((tile: any) => (
                          <option key={tile._id} value={tile._id}>
                            {(tile.title || tile.gameName || tile.gameCode || tile._id) +
                              (tile.platform ? ` (${tile.platform})` : "")}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </>
              )}

              <div className="mb-3 p_0 col-12">
                <label htmlFor="theme" className="mb_5 d_block">
                  Catalog:
                </label>
                <select
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  id="catalog"
                  name="catalog"
                  value={formData?.catalog}
                >
                  <option value="">none</option>
                  <option value="Game Shows">Game Shows</option>
                  <option value="Baccarat">Baccarat</option>
                  <option value="Roulette">Roulette</option>
                  <option value="Dice">Dice</option>
                  <option value="Traditional Games">Traditional Games</option>
                  <option value="Card Games">Card Games</option>
                  <option value="Others">Others</option>
                  <option value="Table">Table</option>
                  <option value="Slot">Slot</option>
                  <option value="Fishing">Fishing</option>
                  <option value="Egame">Egame</option>
                </select>
              </div>

              <div className="mb-3 p_0 col-12">
                <label style={{ display: "block", marginBottom: 3 }}>
                  isLatest:
                </label>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "2px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isLatest: true,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isLatest === true
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.isLatest === true ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isLatest === true
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isLatest === true && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    On
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isLatest: false,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isLatest === false
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.isLatest === false ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isLatest === false
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isLatest === false && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    Off
                  </button>
                </div>
              </div>

              <div className="mb-3 p_0 col-12">
                <label style={{ display: "block", marginBottom: 3 }}>
                  Hot:
                </label>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "2px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isHot: true,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isHot === true
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.isHot === true ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isHot === true
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isHot === true && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    On
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isHot: false,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isHot === false
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.isHot === false ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isHot === false
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isHot === false && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    Off
                  </button>
                </div>
              </div>

              <div className="mb-3 p_0 col-12">
                <label style={{ display: "block", marginBottom: 3 }}>
                  Launch Game Table (Provider List):
                </label>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "2px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isLaunchGameTable: true,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isLaunchGameTable === true
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight:
                        formData.isLaunchGameTable === true ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isLaunchGameTable === true
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isLaunchGameTable === true && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    On
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        isLaunchGameTable: false,
                      }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.isLaunchGameTable === false
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight:
                        formData.isLaunchGameTable === false ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.isLaunchGameTable === false
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.isLaunchGameTable === false && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    Off
                  </button>
                </div>
              </div>
            </div>

            <div className="col-6 p_15">
              {/* gameCode, gameName, gameType, platform, and gameLimit */}
              <div className="mb-3 p_0 col-12">
                <label htmlFor="domain" className="mb_5 d_block">
                  Game Code:
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="gameCode"
                  type="text"
                  value={formData.gameCode}
                />
              </div>
              <div className="mb-3 p_0 col-12">
                <label htmlFor="gameTableId" className="mb_5 d_block">
                  Table ID:
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="gameTableId"
                  type="text"
                  value={formData.gameTableId || ""}
                  placeholder="Optional, for example 1 or 71"
                />
                <span style={{ display: "block", marginTop: 6, fontSize: 12, color: "#667085" }}>
                  Leave empty unless this live game must open a specific table. Sexy Baccarat Classic uses 1.
                </span>
              </div>
              <div className="mb-3 p_0 col-12">
                <label htmlFor="domain" className="mb_5 d_block">
                  Game Name:
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="gameName"
                  type="text"
                  value={formData.gameName}
                />
              </div>
              <div className="mb-3 p_0 col-12">
                <label htmlFor="domain" className="mb_5 d_block">
                  Game Type:
                  {websiteTheme === "velki" && (
                    <span style={{ color: "#dc3545" }}> *</span>
                  )}
                </label>
                {websiteTheme === "velki" ? (
                  <select
                    className="form-control"
                    name="gameType"
                    value={velkiGroupFromGameType(formData.gameType)}
                    onChange={(e) => {
                      const nextType = canonicalVelkiGameType(e.target.value);
                      setFormData((prev) => ({
                        ...prev,
                        gameType: nextType,
                        insertAfter: "",
                      }));
                    }}
                  >
                    <option value="">Select game type</option>
                    {VELKI_GAME_GROUPS.map((group) => (
                      <option key={group.key} value={group.key}>
                        {group.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="form-control"
                    onChange={(e) => handleInputChange(e)}
                    name="gameType"
                    type="text"
                    value={formData.gameType}
                  />
                )}
                {websiteTheme === "velki" && (
                  <span style={{ display: "block", marginTop: 6, fontSize: 12, color: "#667085" }}>
                    Live order is kept inside each catalog. Other types use one order for the whole tab.
                  </span>
                )}
              </div>
              <div className="mb-3 p_0 col-12">
                <label htmlFor="domain" className="mb_5 d_block">
                  Platform:
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="platform"
                  type="text"
                  value={formData.platform}
                />
              </div>
              <div className="mb-3 p_0 col-12">
                <label htmlFor="domain" className="mb_5 d_block">
                  Game Limit:
                </label>
                <input
                  className="form-control"
                  onChange={(e) => handleInputChange(e)}
                  name="gameLimit"
                  type="text"
                  value={formData.gameLimit}
                />
              </div>

              <ImageUpload
                key={imageUploadKey}
                label={
                  <span>
                    Image{" "}
                    <span
                      style={{
                        color: "#dc3545",
                      }}
                    >
                      *
                    </span>
                  </span>
                }
                topClass="mb-0 p_0 col-12"
                filename={formData.image}
                name="image"
                setFileName={handleImageUpload}
                validateImage={true}
                error={Validator.current.message(
                  "image",
                  formData.image,
                  "required",
                )}
                domain={websiteDomain}
              />
            </div>

            <div className="col-12">
              <div className="card_footer">
              <input
                style={{
                  background: isHover
                    ? hexToYIQTextColor(
                        getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                      )
                    : getTheme(DD?.colorSchema)?.backgroundColor,
                  color: isHover
                    ? getTheme(DD?.colorSchema)?.backgroundColor
                    : hexToYIQTextColor(
                        getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                      ),
                  border: `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor}`,
                  height: "33px",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="btn_black"
                type="submit"
                value="Save"
                onClick={(e) => handleSubmitClick(e)}
              />
              <button
                type="button"
                onClick={(e) => handleCancelClick(e)}
                className="btn btn-sm btn-default"
                style={{ marginBottom: 0 }}
              >
                Cancel
              </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditDashBoard;
